import ContactBanner from './ContactBanner';
export default ContactBanner;
